import type { PixShape } from '../components/marketing/PixPaymentModal';

export const PENDING_CHECKOUT_STORAGE_KEY = 'rostech_saas_checkout_pending';

export type PendingCheckoutSnapshot = {
  continuationToken: string;
  chargedPaymentMethod: 'pix' | 'boleto';
  planId: string;
  period: string;
  pixPayload?: PixShape | null;
  bankSlipUrl?: string | null;
  invoiceUrl?: string | null;
};

export function savePendingCheckout(snapshot: PendingCheckoutSnapshot): void {
  try {
    sessionStorage.setItem(PENDING_CHECKOUT_STORAGE_KEY, JSON.stringify(snapshot));
  } catch {
    /* ignore */
  }
}

export function loadPendingCheckout(): PendingCheckoutSnapshot | null {
  try {
    const raw = sessionStorage.getItem(PENDING_CHECKOUT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingCheckoutSnapshot;
    if (!parsed?.continuationToken || !parsed?.chargedPaymentMethod) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingCheckout(): void {
  try {
    sessionStorage.removeItem(PENDING_CHECKOUT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Plano/ciclo da cobrança PIX ou boleto já gerada no checkout. */
export function getChargedCheckoutPlanPeriod(): { planId: string; period: string } | null {
  const stored = loadPendingCheckout();
  if (!stored?.chargedPaymentMethod) return null;
  return { planId: stored.planId, period: stored.period };
}

export function needsCheckoutPlanChangeConfirm(
  nextPlanId: string,
  nextPeriod: string,
  pixAwaitingPayment: boolean
): boolean {
  if (!pixAwaitingPayment) return false;
  const charged = getChargedCheckoutPlanPeriod();
  if (!charged) return false;
  return charged.planId !== nextPlanId || charged.period !== nextPeriod;
}
